export const typeConfig = {
residential: {
    labels: {
      companyName: "Owner Name",
      customerName: "Resident Name",
      customerList: "Resident List",
      subCustomerName: "Tenant Name",
      customer: "Resident",
      subCustomer: "Tenant"
    },
    hiddenFields: ["product_name", "model","amc","productModel"], 
  },
  service_sector: {
    labels: {
      companyName: "Company Name",
      customerName: "Customer Name",
      customerList: "Customer List",
      subCustomerName: "Sub Customer Name",
      customer: "Customer",
      subCustomer: "Sub Customer"
    },
    hiddenFields: [], 
  },
};
